import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-deep-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <img 
              className="h-12 mb-4" 
              src="/images/protec_logo_updated.png" 
              alt="Protec Services & Distribution" 
            />
            <p className="text-sm mt-2">
              Quality automotive monitors and interior electronics assembly and distribution.
            </p>
          </div>
          
          <div className="col-span-1">
            <h3 className="text-lg font-montserrat font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-silver">Home</a></li>
              <li><a href="/about" className="hover:text-silver">About Us</a></li>
              <li><a href="/services" className="hover:text-silver">Services</a></li>
              <li><a href="/contact" className="hover:text-silver">Contact</a></li>
            </ul>
          </div>
          
          <div className="col-span-1">
            <h3 className="text-lg font-montserrat font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="/services#assembly" className="hover:text-silver">Assembly</a></li>
              <li><a href="/services#inspection" className="hover:text-silver">Inspection</a></li>
              <li><a href="/services#consolidation" className="hover:text-silver">Parts Consolidation</a></li>
              <li><a href="/services#distribution" className="hover:text-silver">Distribution</a></li>
            </ul>
          </div>
          
          <div className="col-span-1">
            <h3 className="text-lg font-montserrat font-semibold mb-4">Contact Us</h3>
            <address className="not-italic">
              <p className="mb-2">480 N 2nd. Street</p>
              <p className="mb-2">Rogers City, MI 49779</p>
              <p className="mb-2">Phone: +1 (989) 351-7328</p>
              <p className="mb-2">Email: moelkammash@protec-llc.com</p>
            </address>
          </div>
        </div>
        
        <div className="border-t border-blue-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm">&copy; {new Date().getFullYear()} Protec Services & Distribution. All rights reserved.</p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-4">
               <li><a href="/privacy" className="hover:text-silver">Privacy Policy</a></li>
            <li><a href="/terms" className="hover:text-silver">Terms of Service</a></li>>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
